import PublicUser from 'public/interfaces/PublicUser';
import isDoctor from 'public/utils/isDoctor';
import isPatient from 'public/utils/isPatient';
import {useUserContext} from 'shared/contexts/UserContext/useUserContext';

export default function usePublicUser(): PublicUser | null {
  const {user, company} = useUserContext();

  return user
    ? {
        id: user.id,
        name: user.name,
        surname: user.surname,
        fullname: user.fullname,
        email: user.email,
        locale: user.locale,
        isLoggedIn: Boolean(user),
        isPatient: isPatient(user),
        isDoctor: isDoctor(user),
        isAdmin: isDoctor(user) && user.isAdmin,
        company: {
          name: company?.name,
          termsAndConditions: company?.termsAndConditions
        }
      }
    : null;
}
